import type { FilterSortOption } from '@jane/search/types';
import { FilterSortId } from '@jane/search/types';

export const brandSortOptions: FilterSortOption[] = [
  {
    id: FilterSortId.Default,
    isDefault: true,
    label: 'Default',
    value: 'default',
  },
  {
    id: FilterSortId.AZ,
    isDefault: false,
    label: 'A-Z',
    value: 'a-z',
  },
  {
    id: FilterSortId.Upvote,
    isDefault: false,
    label: 'Upvotes',
    value: 'upvote',
  },
];
